import React, { useEffect } from 'react';
import { useRecoilState } from 'recoil';

import { TableFiltersWithDate } from 'components';
import { reportFiltersState, reportTextState } from 'store';
import { ReportFilter } from 'types';

type ReportFiltersProps = {
  filters: ReportFilter[];
  collapsible?: boolean;
};

export const ReportFilters: React.FC<ReportFiltersProps> = ({
  filters,
  collapsible = true,
}) => {
  const [reportFilters, setReportFilters] = useRecoilState(reportFiltersState);
  useEffect(() => {
    setReportFilters(filters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <TableFiltersWithDate
      filters={reportFilters}
      onSetSelectedFilters={(_filters) => setReportFilters(_filters as ReportFilter[])}
      collapsible={collapsible}
      showDateFilter={false}
      textSearchState={reportTextState}
    />
  );
};
